import React from 'react';

import { useTranslation } from 'react-i18next';

import { ReactComponent as MetaMaskIcon } from '@pkg/assets/icons/v2/metamask.svg';
import { useMetaMask, useMobile } from '@pkg/hooks';

import { Typography } from '../../DesignSystem';

import './MetaMaskStatus.scss';

interface MetaMaskStatusProps {
    classes?: string[];
}

export const MetaMaskStatus = ({ classes }: MetaMaskStatusProps) => {
    const { isMetaMaskConnected } = useMetaMask();
    const { isMobile } = useMobile();
    const { t } = useTranslation(['nft']);

    const text = isMobile ? t('metamask_connected') : t('metamask_wallet_connected');
    return (
        <div className={classes ? classes.join(' ') : ''}>
            {isMetaMaskConnected && (
                <div className="yat-metamask-status">
                    <div className="yat-metamask-status__icon">
                        <MetaMaskIcon />
                    </div>
                    <div className="yat-metamask-status__dot">
                        <div />
                    </div>
                    <Typography type="label" size={14} classes={['yat-metamask-status__label']}>
                        {text}
                    </Typography>
                </div>
            )}
        </div>
    );
};
